import { FieldSchema } from "../../../Schema";

export const comment: FieldSchema = {
  grid: {
    displayed: true,
    order: 13,
    sortable: false,
  },
  name: "comment",
  display: {
    displayed: true,
  },
  form: { label: "Comment" },
};
